import React from 'react';
import ConversionList from './ConversionList/ConversionList.container';
import { useI18n } from 'utils/I18n/context';

const ConversionPage = () => {
    const { t } = useI18n();
    const staticNames = t?.conversionPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content statistics conversion">
                <div className="ibox">
                    <ConversionList />
                </div>
            </section>
        </React.Fragment>
    );
};

export default ConversionPage;
